import { render } from "./Dashboard6.vue?vue&type=template&id=894259ba&scoped=true"
import script from "./Dashboard6.vue?vue&type=script&lang=js"
export * from "./Dashboard6.vue?vue&type=script&lang=js"

import "./Dashboard6.vue?vue&type=style&index=0&id=894259ba&lang=css"
import "./Dashboard6.vue?vue&type=style&index=1&id=894259ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-894259ba"]])

export default __exports__